<template>
    <div
      v-if="variant?.product?.status === STATUS.ACTIVE && variant?.product?.supplier?.id === auth?.idSupplier && customer?.supplier?.availableInspirationPoints >= 10"
      v-tippy="$t('text-top-this-ad')"
      :class="[ 'w-10 h-10 cursor-pointer flex-shrink-0 flex items-center justify-center rounded-xl', accent ? 'border border-primary-neutral hover:border-primary-dark-hover hover:bg-primary-dark-hover text-light' : 'border border-primary-dark hover:border-primary-dark-hover hover:bg-primary-dark-hover text-primary-dark hover:text-light' ]"
      @click="handleClick"
    >
        <ToppingIcon class="w-4 h-4" />
    </div>
</template>

<script setup>
import { STATUS } from "@utils/constants";
import { useAuthStore } from '@stores/auth';
import { useCustomerStore } from '@stores/customer';
import { useSelectedStore } from '@stores/selected';
import { useUIStore } from '@stores/ui';
import ToppingIcon from "@components/icons/topping-icon";

const props = defineProps({
  variant: {
    type: Object,
    default: () => {}
  },
  accent: {
    type: Boolean,
    default: false
  }
});

const { $eventBus } = useNuxtApp();
const auth = useAuthStore();
const customer = useCustomerStore();
const store = useSelectedStore();
const ui = useUIStore();

const handleClick = () => {
  if (!checkAuth() || (customer?.supplier?.availableInspirationPoints ?? 0) < 10) {
    return;
  }

  if (ui.modalView && ui.displayModal) {
    store.setAction('RETURN_TO_PRODUCT_MODAL');
    $eventBus.emit('modal:close');
  }

  store.setVariant(props.variant);
  $eventBus.emit('modal:open', 'CONFIRM_TOP_VARIANT');
}

</script>
